import { render } from "./ProgramView.vue?vue&type=template&id=5571b2cc"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__